module.exports = __webpack_public_path__ + "img/ULGA-logo.c5cc454e.svg";